import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@pandiafi/design-system'

import { Error } from 'components/Error'
import { useReturnToPreviousView } from 'hooks/useReturnToPreviousView/useReturnToPreviousView'

interface AccessDeniedProps {
  message: string
  resetErrorBoundary: () => void
}

export const AccessDenied: React.FC<AccessDeniedProps> = ({
  message,
  resetErrorBoundary,
}) => {
  const { t } = useTranslation(['common'])
  const returnToPreviousView = useReturnToPreviousView()

  return (
    <Error
      message={message}
      illustration="house-locked"
      action={
        <Button
          onClick={() => {
            returnToPreviousView()
            resetErrorBoundary()
          }}
        >
          {t('common:back')}
        </Button>
      }
    />
  )
}
